//export const apiUrl = 'http://localhost:5001/api/app/rma';
//export const apiUrl = 'https://maxidev.api.dev1.codethekiwi.com/api/app/rma';
export const apiUrl = 'https://radis.maxicleaning.be/api/app/rma';